export default "__VITE_ASSET__CceDDVXz__"